import { DeleteIcon } from "assets/icons";
import { If } from "components";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Icon, Input } from "ui";

import { AttributeTypes } from "../../../../constants";
import { AttributeBlock } from "../../../AttributeBlock";
import { DynamicAttributesBlockProps } from "../SubChildCategoryForm.types";

const ProductDetailsBlock = ({
  control,
  attributes,
  onAppendAttribute,
  onRemoveAttribute
}: DynamicAttributesBlockProps) => {
  const { t } = useTranslation();

  return (
    <AttributeBlock
      title={t("Product Details")}
      subtitle={t(
        "Value for each attribute will be filled manually while creating a product."
      )}
      appendLabel={t("Add new attribute")}
      onAppend={onAppendAttribute(AttributeTypes.Related)}
    >
      {attributes.map((attribute, attributeIndex) => {
        return (
          <If
            key={attribute.attributeId}
            condition={
              attribute.type === AttributeTypes.Related && !attribute.delete
            }
          >
            <Controller
              control={control}
              name={`attributes.${attributeIndex}.name`}
              render={({
                field: { value, onChange },
                fieldState: { error }
              }) => (
                <Input
                  placeholder={t("Enter attribute title")}
                  maxLength={50}
                  value={value}
                  onChange={onChange}
                  errorMessage={error?.message}
                  action={
                    <Icon
                      as={DeleteIcon}
                      type="button"
                      boxSize={24}
                      color="#A8A8BB"
                      onClick={onRemoveAttribute(attributeIndex)}
                      isDisabled={attribute.isValidToDelete === false}
                    />
                  }
                />
              )}
            />
          </If>
        );
      })}
    </AttributeBlock>
  );
};

export default ProductDetailsBlock;
